import React from 'react';
import { Outlet } from 'react-router-dom';
import { useFeatureFlags } from '../../hooks/useFeatureFlags';
import UpgradePrompt from './UpgradePrompt';

const FeatureProtectedRoute = ({
  featureFlag,
  featureName = 'This feature',
  description,
  upgradePromptProps = {},
}) => {
  const { hasFeatureFlag } = useFeatureFlags();

  if (!hasFeatureFlag(featureFlag)) {
    return (
      <div className="p-4">
        <UpgradePrompt
          featureName={featureName}
          description={description}
          {...upgradePromptProps}
        />
      </div>
    );
  }

  return <Outlet />;
};

export default FeatureProtectedRoute;
